module.exports = __webpack_public_path__ + "images/pharos_smallfc3ffbd68acdf4a82147678f3efe980c.png";